







































import LineItemsForm from "@/components/repair-estimate/LineItemsForm.vue";
import { CurrencyEnum } from "@/lib/enum/currency.enum";
import { TotalLossType } from "@/lib/enum/total-loss-type.enum";
import { getAutocompleteFilter } from "@/lib/utility/filter";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { IRepairEstimate } from "@/models/repair-estimate.entity";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";

@Component({
  components: { LineItemsForm }
})
export default class RepairEstimateForm extends mixins(RulesMixin) {
  @Prop({ required: true }) value!: IRepairEstimate;
  @Prop({ type: Boolean, default: false }) disabled!: boolean;
  @Prop({ type: Boolean, default: false }) showDate!: boolean;

  readonly CurrencyEnum = CurrencyEnum;
  readonly TotalLossType = TotalLossType;
  readonly getAutocompleteFilter = getAutocompleteFilter;
}
